/* eslint-disable no-undef */
/* eslint-disable no-console */
import axios from "axios";
import { superAppSSRUrl, superAppCmsAuthKeys } from "../../client/constants/url-constants";

const DEBUG = process.env.NODE_ENV === "development";
const BASE_API_URL = superAppSSRUrl();

/* Create axios instance */
const api = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        "Content-Type": "application/json",
        "auth-token": superAppCmsAuthKeys()
    }
    // withCredentials: true,
});

api.interceptors.request.use((config) => {
    /** In dev, intercepts request and logs it into console for dev */
    if (DEBUG) { console.info("✉️ ", config); }
    return config;
}, (error) => {
    if (DEBUG) { console.error("✉️ ", error); }
    return Promise.reject(error);
});

/**
 * Passes response.data to services.
 * In dev, intercepts response and logs it into console for dev
 */
api.interceptors.response.use((response) => {
    if (DEBUG) { console.info("📩 ", response); }
    return response;
}, (error) => {
    if (error.response && error.response.data) {
        if (DEBUG) { console.error("Error: ", error.response.data); }
        return Promise.reject(error.response.data);
    }
    if (DEBUG) { console.error("📩 ", error); }
    return Promise.reject(error.message);
});

export default api;
